import React from 'react';
import { integrations } from '../../mock';
import { Lock, Plug, Link2 } from 'lucide-react';

export default function Integrations() {
  return (
    <section className="py-20 lg:py-32 bg-[#F1EDE4]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-8 mb-12 lg:mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-neutral-500 mb-4">
              <span className="w-6 h-px bg-[#4ECDC4]" />
              <span>Flexible Lead Delivery</span>
            </div>
            <h2 className="text-4xl lg:text-6xl tracking-tight leading-[1.02] font-medium">
              Built around <span className="font-serif italic font-normal">your stack.</span>
            </h2>
          </div>
          <div className="lg:col-span-4">
            <p className="text-neutral-600 text-[15px]">We deliver into the platforms your revenue team already runs on.</p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          <div className="bg-white border border-neutral-200 rounded-2xl p-8 hover:border-[#0F1C40] transition reveal">
            <Plug className="w-6 h-6 text-[#4ECDC4] mb-6" strokeWidth={1.5} />
            <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500 mb-2">Certified Delivery Team</div>
            <h3 className="text-2xl font-medium mb-6 tracking-tight">Partner Platforms</h3>
            <div className="space-y-3">
              {integrations.partners.map((p) => (
                <div key={p} className="flex items-center justify-between py-2 border-b border-neutral-100">
                  <span className="text-sm font-medium">{p}</span>
                  <span className="text-[10px] font-mono text-emerald-600">CONNECTED</span>
                </div>
              ))}
            </div>
            <p className="text-xs text-neutral-500 mt-6">Plug-and-play into industry-standard lead platforms.</p>
          </div>

          <div className="bg-[#0F1C40] text-[#F1EDE4] rounded-2xl p-8 reveal">
            <Link2 className="w-6 h-6 text-[#4ECDC4] mb-6" strokeWidth={1.5} />
            <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500 mb-2">Custom APIs</div>
            <h3 className="text-2xl font-medium mb-6 tracking-tight">CRM Integrations</h3>
            <div className="space-y-3">
              {integrations.crm.map((c) => (
                <div key={c} className="flex items-center justify-between py-2 border-b border-neutral-800">
                  <span className="text-sm font-medium">{c}</span>
                  <span className="text-[10px] font-mono text-[#4ECDC4]">NATIVE</span>
                </div>
              ))}
              <div className="pt-2 text-[11px] font-mono text-neutral-500">+ more on request</div>
            </div>
            <p className="text-xs text-neutral-400 mt-6">Native, real-time delivery into your CRM & MAP.</p>
          </div>

          <div className="bg-white border border-neutral-200 rounded-2xl p-8 hover:border-[#0F1C40] transition reveal">
            <Lock className="w-6 h-6 text-[#4ECDC4] mb-6" strokeWidth={1.5} />
            <div className="text-[10px] font-mono uppercase tracking-widest text-neutral-500 mb-2">Secure Portal</div>
            <h3 className="text-2xl font-medium mb-6 tracking-tight">Encrypted Delivery</h3>
            <div className="space-y-3">
              {integrations.security.map((s, i) => (
                <div key={s} className="flex items-start gap-3 py-1">
                  <span className="text-[10px] font-mono text-neutral-400">{String(i + 1).padStart(2, '0')}</span>
                  <span className="text-sm">{s}</span>
                </div>
              ))}
            </div>
            <p className="text-xs text-neutral-500 mt-6">Private, client-branded delivery environment with full audit trail.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
